export const LICENSE_KEY =
    "ac8c44d2650f10c5456f59e7602dc69cTz0xMTE5MzIsRT0xNzc3MDc1MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=";
export const GOOGLE_MAP_KEY = "AIzaSyA3CvTeFPuHo7ePjm5YOva66gR-pFWZvPc";
export const X_API_KEY = "69e5ca40-0dbb-4ba3-a008-98a702990564";
export const APLICACION_COD = "MIAWEBCLI";
